import { useEffect } from "react";
import cn from "classnames";
import useGenerateQr from "@/hooks/generator/userGenerateQr/userGenerateQr";
import { useConfig, useGenerateResult } from "@/states/common.state";
import { useIsloading } from "@/states/ui.state";
import { useUserDesign } from "@/states/design.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import style from "./Shapes.module.scss";
import { useTranslations } from "next-intl";
import { useMediaQuery } from "react-responsive";
import { EDGES_LIST } from "@/constant/edges.repo";
import Image from "next/image";
import { customizeCdnLink } from "@/helper/customize.helper";
import { BODY_TYPE_LIST } from "@/constant/body-types";
const Shapes = () => {
  const {
    result
  } = useGenerateResult();
  const {
    config,
    payload,
    files
  } = useConfig();
  const {
    color,
    shape,
    setShape
  } = useUserDesign();
  const {
    setIsloading
  } = useIsloading();
  const isMobile = useMediaQuery({
    maxWidth: 600
  });
  const {
    mutateHomeQr,
    mutateLoading
  } = useGenerateHomeQr(false);
  const {
    isLoadingConfigUpdate
  } = useGenerateQr();
  const t = useTranslations("Home");
  const defaultSelectedShape = config?.pattern;
  const defaultSelectedEdge = config?.marker_top_left?.marker;
  useEffect(() => {
    if (!defaultSelectedShape || shape.body_type !== defaultSelectedShape && isLoadingConfigUpdate) {
      setShape({
        body_type: defaultSelectedShape || "default"
      });
    }
    if (!defaultSelectedEdge || shape.edges !== defaultSelectedEdge && isLoadingConfigUpdate) {
      setShape({
        edges: defaultSelectedEdge || "default"
      });
    }
  }, [defaultSelectedShape, defaultSelectedEdge, isLoadingConfigUpdate]);
  const onBodyType = (key: string) => {
    setShape({
      body_type: key
    });
    setIsloading(true);
    if (!result && !mutateLoading || !isLoadingConfigUpdate) {
      mutateHomeQr({
        params: {
          ...payload,
          files
        },
        configParams: {
          pattern: key
        }
      });
    }
  };
  const onShapesType = (key: string) => {
    setShape({
      edges: key
    });
    setIsloading(true);
    const newConfig = {
      marker_top_left: {
        marker: key,
        outer_color: color.frontcolor,
        inner_color: color.frontcolor
      }
    };
    if (!result && !mutateLoading || !isLoadingConfigUpdate) {
      mutateHomeQr({
        params: {
          ...payload,
          files
        },
        configParams: newConfig
      });
    }
  };
  const filteredBodyTypes = isMobile ? BODY_TYPE_LIST.filter(item => item.isMobile) : BODY_TYPE_LIST.filter(item => item.guest === undefined);
  const filteredEdges = isMobile ? EDGES_LIST.filter(item => item.isMobile) : EDGES_LIST.filter(item => item.guest === undefined);
  return <div className={style.wrapper} data-sentry-component="Shapes" data-sentry-source-file="Shapes.tsx">
      <span>{t("bodyType")}</span>
      <div className={style.flex}>
        {filteredBodyTypes.map(({
        key
      }, index) => <button key={index.toString() + key} disabled={shape.body_type === key} className={cn(style.item, {
        [style.active]: shape.body_type === key
      })} onClick={() => onBodyType(key)}>
            <Image src={customizeCdnLink("patterns", key)} alt={key} height={52} width={52} />
          </button>)}
      </div>
      <span className={style.edges}>{t("edges")}</span>
      <div className={style.flex}>
        {filteredEdges.map(({
        key
      }, index) => <button key={index.toString() + key} disabled={shape.edges === key} className={cn(style.item, {
        [style.active]: shape.edges === key
      })} onClick={() => onShapesType(key)}>
            <Image src={customizeCdnLink("eyes", key)} alt={key} height={52} width={52} />
          </button>)}
      </div>
    </div>;
};
export default Shapes;